import { HttpContextToken } from '@angular/common/http';

/** Per-request wire secret for decrypting the matching API response. */
export const REQUEST_WIRE_SECRET = new HttpContextToken<string | null>(() => null);
